@if (!field['isHidden']) {
  <div class="formly__wrapper">
    <!--*ngIf="displayText !== 'ID'"-->
    @if (displayHeader) {
      <atom-accordion displayMode="flat">
        <atom-accordion-header header [grow]="true" [align]="'center'">
          <div title>
            <div class="d-flex align-items-center justify-content-between">
              <!--ICONS-->
              <div class="d-flex align-items-center">
                <!--ERRORS-->
                @if (axErrorObject.count > 0) {
                  <span
                    class="d-flex align-items-center badge rounded-circle badge-primary mr-4">
                    @if (axErrorObject.type == 'error') {
                      <atom-image [type]="'icon'"
                        [src]="icons.Warning_triangle" [color]="colors.Red">
                      </atom-image>
                    }
                    @if (axErrorObject.type == 'warning') {
                      <atom-image [type]="'icon'"
                        [src]="icons.Notification_active" [color]="colors.Purple">
                      </atom-image>
                    }
                  </span>
                }
                @if (axErrorObject.count <= 0 && formControl.status === 'INVALID') {
                  <span
                    class="d-flex align-items-center badge rounded-circle badge-primary mr-4">
                    <atom-image [type]="'icon'" [src]="icons.Warning_triangle" [color]="colors.Red">
                    </atom-image>
                  </span>
                }
                <!--GREEN TICK-->
                @if ((axErrorObject.count === 0 && formControl.status === 'VALID') || formControl.disabled) {
                  <span
                    class="d-flex align-items-center badge rounded-circle badge-danger mr-4">
                    <atom-image [type]="'icon'" [src]="icons.Check" [color]="colors.Green">
                    </atom-image>
                  </span>
                }
                <!--TEXT-->
                <span><strong>{{ displayText | BreakString }}</strong></span>
              </div>
            </div>
          </div>
          @if (field['showRemoveButton']) {
            <atom-button post [type]="buttonType.Secondary" [width]="'220px'"
              (click)="removeFromParent($event)">
              <div text>Verwijder</div>
            </atom-button>
          }
        </atom-accordion-header>
        <div body class="formly__object--body">
          @if (axErrorDisplayObject.errors.length > 0) {
            <span
              class="d-flex align-items-center badge rounded-circle badge-primary mr-4">
            </span>
          }
          @if (axErrorDisplayObject.errors.length > 0) {
            <div class="formly-feedback mb-2 mt-0">
              @for (err of axErrorDisplayObject.errors; track $index; let index = $index) {
                <div
                  [ngClass]="err.Type?.toLowerCase() === 'error' ? 'formly-feedback--error' : 'formly-feedback--warning'">
                  @if (err.Message !== '') {
                    <div class="d-flex p-1">
                      <div class="pr-1">
                        @if (axErrorDisplayObject.type?.toLowerCase() === 'error') {
                          <atom-image [type]="'icon'"
                            [src]="icons.Warning_triangle" [color]="colors.Red">
                          </atom-image>
                        }
                        @if (axErrorDisplayObject.type?.toLowerCase() === 'warning') {
                          <atom-image [type]="'icon'"
                            [src]="icons.Notification_active" [color]="colors.Purple">
                          </atom-image>
                        }
                      </div>
                      <div>{{err}}</div>
                    </div>
                    @if (index > 0 && index !== err.errors?.length - 1) {
                      <hr />
                    }
                  }
                </div>
              }
            </div>
          }
          @for (field of field.fieldGroup; track $index) {
            <formly-field
              [field]="field"
              [ngStyle]="calcFlexValue(field)">
            </formly-field>
          }
        </div>
      </atom-accordion>
    }
    @if (!displayHeader) {
      <div>
        <div class="pb-2">
          @for (f of field.fieldGroup; track $index) {
            <formly-field [field]="f"></formly-field>
          }
        </div>
      </div>
    }
  </div>
}
